import React from 'react';
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer
} from 'recharts';

const LatencyChart = ({ data, themeColors }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-4 md:p-6 h-[420px] flex flex-col">
      <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-5">
        APIs Latency
      </h2>
      <div className="h-[315px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" opacity={0.3} />
            <XAxis 
              dataKey="endpoint" 
              stroke="#94a3b8" 
              tick={{ fill: '#94a3b8', fontSize: 12 }}
            />
            <YAxis 
              stroke="#94a3b8" 
              tick={{ fill: '#94a3b8', fontSize: 12 }}
              tickFormatter={(value) => `${value}ms`}
              domain={[0, 500]}
            />
            <Tooltip 
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  const data = payload[0].payload;
                  return (
                    <div className="bg-white dark:bg-slate-700 rounded-lg shadow-xl p-4 border border-gray-100 dark:border-slate-600">
                      <p className="font-semibold text-gray-800 dark:text-gray-100 mb-2">
                        {data.endpoint}
                      </p>
                      <div className="space-y-2">
                        <div className="flex items-center gap-2 text-sm">
                          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: themeColors.primary }} />
                          <span className="text-gray-600 dark:text-gray-300">Minimum:</span>
                          <span className="font-medium text-gray-800 dark:text-gray-100">
                            {data.minLatency}ms
                          </span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: themeColors.accent }} />
                          <span className="text-gray-600 dark:text-gray-300">Maximum:</span>
                          <span className="font-medium text-gray-800 dark:text-gray-100">
                            {data.maxLatency}ms
                          </span>
                        </div>
                        <div className="flex items-center gap-2 text-sm">
                          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor:"#F59E0B" }} />
                          <span className="text-gray-600 dark:text-gray-300">Average:</span>
                          <span className="font-medium text-gray-800 dark:text-gray-100">
                            {data.avgLatency}ms
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              }}
              cursor={{ fill: "var(--tooltip-cursor-light)" }}
            />
            <Bar 
              dataKey="minLatency" 
              name="Minimum Latency"
              fill={themeColors.primary}
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              dataKey="maxLatency" 
              name="Maximum Latency"
              fill={themeColors.accent}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      
      <div className="mt-2 flex items-center justify-center gap-5 text-sm flex-shrink-0">
        <div className="flex items-center">
        <span 
            className="w-3 h-3 rounded-sm mr-2"
            style={{ backgroundColor: themeColors.primary }}
          ></span>
        <span className="text-sm text-gray-700 dark:text-gray-300 truncate">Minimum Latency</span>
        </div>
        <div className="flex items-center">
        <span 
            className="w-3 h-3 rounded-sm mr-2"
            style={{ backgroundColor: themeColors.accent }}
          ></span>
        <span className="text-sm text-gray-700 dark:text-gray-300 truncate">Maximum Latency</span>
        </div>
      </div>
    </div>
  );
};

export default LatencyChart; 